import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';

import Page from '../Page';
import BroadcastLinks from './BroadcastLinks';
import BroadcastVideo from './BroadcastVideo';
import SettingsInfo from './SettingsInfo';
import BroadcastResolutions from './BroadcastResolutions';

import { BACK_TO_AUCTION_SALES } from '../BulkBidding/constants';
import { isProd, myAuctionPath } from '../../utilities/UrlPaths';
import { getMilliCastToken } from '../../modules/broadcast/thunks';
import { checkDeviceSupport, MILLI_CAST_TEST_URL } from './utils';
import './Broadcast.scss';
import { BROADCAST_DATA_RESET } from '../../modules/broadcast/reducer';

const Broadcast = () => {
  const dispatch = useDispatch();
  const { eventId } = useParams();

  const [audioDevices, setAudioDevices] = useState([]);
  const [videoDevices, setVideoDevices] = useState([]);
  const [streamResolutions, setStreamResolutions] = useState({ height: 240, width: 426 });
  const [settings, setSettings] = useState({
    hasWebcam: false,
    hasMicrophone: false,
    isMicrophoneAlreadyCaptured: false,
    isWebcamAlreadyCaptured: false
  });

  const streamAlias = !isProd ? '-stage' : '';

  const updateDevices = async () => {
    const { streamSettings = {}, audio = [], video = [] } = await checkDeviceSupport();
    setVideoDevices(video);
    setAudioDevices(audio);
    setSettings(streamSettings);
  };

  useEffect(() => {
    updateDevices();
    dispatch(getMilliCastToken(eventId));

    return () => {
      dispatch({
        type: BROADCAST_DATA_RESET
      });
    };
  }, [eventId]);

  return (
    <Page
      header={{ title: 'Video Broadcast' }}
      navLink={{
        displayName: BACK_TO_AUCTION_SALES,
        href: myAuctionPath
      }}
    >
      <Container disableGutters maxWidth={false}>
        <BroadcastVideo
          streamResolutions={streamResolutions}
          videoDevices={videoDevices}
          audioDevices={audioDevices}
          updateDevices={updateDevices}
        />
        <Box display="inline-block">
          <a
            href={`${MILLI_CAST_TEST_URL}/${eventId + streamAlias}`}
            target="__blank"
            className="preview-button-link"
          >
            <Typography variant="h6" color="green" mb={1} fontWeight="bold">
              Preview Stream
            </Typography>
          </a>
        </Box>
        {settings.hasWebcam &&
        settings.hasMicrophone &&
        settings.isMicrophoneAlreadyCaptured &&
        settings.isWebcamAlreadyCaptured ? (
          <SettingsInfo settings={settings} />
        ) : (
          <Typography variant="h6" color="red" mb={1} fontWeight="bold">
            Error - Please check your video and microphone permissions, confirm the permissions are set in the browser settings, and refresh the page.
          </Typography>
        )}
        <BroadcastResolutions setStreamResolutions={setStreamResolutions} />
        <BroadcastLinks />
      </Container>
    </Page>
  );
};

export default Broadcast;
